
import React from 'react';
import { Link } from 'react-router-dom';
import {
    Row,
    Col,
} from "reactstrap"
import PropTypes from 'prop-types'

function UnitTableItem(props) {
    const { data, count ,callbackDelete } = props;
    const onDelete = (e) => {
        callbackDelete(data.unit_code)
    }
    return (
        <tr>
            <td>{data.unit_code}</td>
            <td>{data.unit_name}</td>
            <td>
                <Row className="d-flex align-items-center m-0">
                    <Col xs="auto" sm="auto">
                        <Link className='text-success' to={"/units/"+data.unit_code} >
                            <i className="fas fa-pen"></i>
                        </Link>
                    </Col>
                    <Col xs="auto" sm="auto">
                        <a className='text-danger' onClick={onDelete} >
                            <i className="fas fa-trash"></i>
                        </a>
                    </Col>
                </Row>
            </td>
        </tr>
    )

}
UnitTableItem.propTypes = {
    data: PropTypes.object,
    count: PropTypes.number,
    callbackDelete: PropTypes.func,
}

export default UnitTableItem;
